/**
 * Mitgelieferte Themes (SPEC 8.4).
 *
 * `default` ist leer: das Standardthema steht vollstaendig in `tokens.css`,
 * und eine zweite Kopie derselben Werte waere genau die Doppelung, die
 * irgendwann auseinanderlaeuft.
 *
 * Alle Werte hier sind auf WCAG AA nachgerechnet — `contrast.test.ts` im Web
 * prueft jedes Theme in beiden Farbschemata gegen dieselben Paare wie die
 * Basis. Ein Theme, das durchfaellt, wird nicht ausgeliefert.
 */
export const BUILT_IN_THEMES = [
    {
        id: 'default',
        name: 'Standard',
        light: {},
        dark: {},
    },
    {
        id: 'forest',
        name: 'Wald',
        light: {
            '--color-bg': '#f2f5ef',
            '--color-surface-muted': '#e7ede2',
            '--color-border': '#cdd8c6',
            '--color-accent': '#2b5e33',
            '--color-accent-hover': '#224b29',
            '--color-accent-soft': '#dfeade',
        },
        dark: {
            '--color-bg': '#111710',
            '--color-surface': '#1a221a',
            '--color-surface-muted': '#151c15',
            '--color-surface-raised': '#212b21',
            '--color-border': '#32402f',
            '--color-accent': '#8cc98f',
            '--color-accent-hover': '#a3d6a5',
            '--color-accent-soft': '#1f2c1f',
            '--color-accent-contrast': '#0d150d',
        },
    },
    {
        id: 'ocean',
        name: 'Meer',
        light: {
            '--color-bg': '#eef3f8',
            '--color-surface-muted': '#e3ebf3',
            '--color-border': '#c7d5e3',
            '--color-accent': '#1f4e79',
            '--color-accent-hover': '#173d61',
            '--color-accent-soft': '#dde9f4',
        },
        dark: {
            '--color-bg': '#0f151b',
            '--color-surface': '#182028',
            '--color-surface-muted': '#131a21',
            '--color-surface-raised': '#1f2933',
            '--color-border': '#2e3b48',
            '--color-accent': '#8cc0ea',
            '--color-accent-hover': '#a6cef0',
            '--color-accent-soft': '#182734',
            '--color-accent-contrast': '#0b1219',
        },
    },
    {
        /*
         * Nicht als Geschmacksfrage gedacht, sondern als Zugaenglichkeit: alle
         * Textpaare deutlich ueber dem Mindestwert, Raender sichtbar statt
         * angedeutet.
         */
        id: 'high-contrast',
        name: 'Hoher Kontrast',
        light: {
            '--color-bg': '#ffffff',
            '--color-surface': '#ffffff',
            '--color-surface-muted': '#eeeeee',
            '--color-surface-raised': '#ffffff',
            '--color-border': '#5c5c5c',
            '--color-border-strong': '#000000',
            '--color-text': '#000000',
            '--color-text-muted': '#3a3a3a',
            '--color-accent': '#00407a',
            '--color-accent-hover': '#002f5a',
            '--color-accent-soft': '#dbe8f5',
            '--color-danger': '#8f1610',
            '--color-warning': '#6b3a00',
            '--color-caution': '#524300',
            '--color-success': '#14532b',
            '--color-info': '#00407a',
        },
        dark: {
            '--color-bg': '#000000',
            '--color-surface': '#101010',
            '--color-surface-muted': '#080808',
            '--color-surface-raised': '#1a1a1a',
            '--color-border': '#a8a8a8',
            '--color-border-strong': '#ffffff',
            '--color-text': '#ffffff',
            '--color-text-muted': '#d0d0d0',
            '--color-accent': '#9ecbff',
            '--color-accent-hover': '#bcdcff',
            '--color-accent-soft': '#0d1b2a',
            '--color-accent-contrast': '#000000',
        },
    },
];
//# sourceMappingURL=index.js.map